<template>
	<div class="about-xhorse">
		<div class="title">
			<i class="x-icon-why"></i><span class="x-tit-con">Why Choose Xhorse?</span>
		</div>
		<div class="staff-con">
			<ul class="staff-ll">
				<li>
					<div class="staff-photo x-flow">
						<img :src="staff_1" alt="Xhorse"/>
					</div>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Here we can feel what is open communication, feel mutual trust, and help between colleagues. Learning more and developing rapidly are the availabilities in Xhorse.</p>
							<div class="author">—— Howie</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								Hello, I'm Howie. I started my studies in the fields of mechanical manufacturing and
								automation at Huazhong University of Science and Technology. After graduating from undergraduate university, I went to the Hong Kong University of Science and Technology to get further education for a master's degree, continued to work in the direction of mechanical engineering, and achieved the outstanding results of all-A graduation.
							</p>
							<p>
								Because of my passion for computer science, I decided to devote my working life to this field after graduation. I have been doing plenty of research in the system of robot motion control, which has laid a solid foundation for me to quickly adapt my new job.
							</p>
							<p>
								At present, I am the responsible person of the motion control algorithm of the five-axis numerical control project.
							</p>
						</div>
					</div>
				</li>
				<li>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Xhorse, as a national-level high-tech enterprise, is now on its high-speed way of development. Everyone who chooses here will find what you need, and where you are in your working life.</p>
							<div class="author">—— Annie</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								Hello everyone, Just call me Annie. I gained my undergraduate and master's degree in mechanical engineering at the Wuhan University of Technology. then I joined Xhorse as a mechanical engineer. Then I gained rich experience as being an automation design engineer and a project assistant to the general manager. At present, I am the head of the automation department, responsible for managing the research and development works of the automation department. I have learned more in-depth knowledge in the fields of machinery, electrical, manufacturing, machining control, and laser during the past 4 years.
							</p>
							<p>

							</p>
							<p>

							</p>
						</div>
					</div>
					<div class="staff-photo x-flow">
						<img :src="staff_2" alt="Xhorse"/>
					</div>
				</li>
				<li>
					<div class="staff-photo x-flow">
						<img :src="staff_3" alt="Xhorse"/>
					</div>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Xhorse provides an equal, innovative, and open platform for every young man who has a dream. We are riding with Xhorse to advance together.</p>
							<div class="author">——  Thomas</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								After graduating and entering Xhorse, I became an optical engineer and then worked as a project assistant for a five-axis CNC project. My main work is responsible for the light path design of the project, and at the same time responsible for the promotion of the project. In the work, I came into contact with knowledge of optics, mechanics, algorithms, software, etc. Professional knowledge serves the work, passion, and responsibility to serve the project. A freshman will gradually grow up, and the great changes of Xhorse people will take place stem from their love and responsibility.							</p>
							<p>

							</p>
							<p>

							</p>
						</div>
					</div>
				</li>
				<li>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Xhorse is well-known in the industry for its global leading product technology and service quality. The open technological environment and inclusive innovation atmosphere here deeply attract me, and I believe it will also attract you who will join in the future.</p>
							<div class="author">—— Leonard</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								After obtaining an undergraduate degree in Automation from the Wuhan University of Technology,I joined Xhorse to work as an overseas technical support engineer. At present, my main task is to connect with the company's overseas customers and responsible for product after-sales and overseas promotion. Because of my passion for the automation field, I insist on professional choice and become a member of Xhorse. As a newcomer to the workplace, I will study with an open mind, work hard to improve and keep the passion and hardworking at Xhorse. I will take my dream as a horse and act my glorious youth!
							</p>
							<p>

							</p>
							<p>

							</p>
						</div>
					</div>
					<div class="staff-photo x-flow">
						<img :src="staff_4" alt="Xhorse"/>
					</div>
				</li>
				<li>
					<div class="staff-photo x-flow">
						<img :src="staff_5" alt="Xhorse"/>
					</div>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Xhorse can truly achieve flat management while developing at a high speed so that every young man with dreams can have a stage to show off and create a more brilliant future together.</p>
							<div class="author">—— Evelyn</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								After obtaining a master's degree in mechanical engineering from Huazhong University of Science and Technology，she joined Xhorse as a project assistant to the general manager, responsible for assisting the general manager to coordinate the relationship between the various departments of the company, and to track and evaluate the company's project progress and risks. She has the opportunity to get in touch with more professional knowledge in the fields of machinery, electronics, automation, and smart devices during work time. Because of love, it can be professional, as long as we work with full of enthusiasm, we can definitely reach the other side of our dreams.
							</p>
							<p>

							</p>
							<p>

							</p>
						</div>
					</div>
				</li>
				<!--<li>
					<div class="staff-words x-flow">
						<div class="maxim">
							<i class="x-icon-maxin-left"></i>
							<p>
								Xhorse provides supportive working circumstance along with a wide platform for employees, and encourage them to learn the knowledge about mechanical engineering, hardware development, embedded system, etc. Also, it enables brilliants to connect with each other and explore the edge of intelligence technology.</p>
							<div class="author">—— Lili</div>
							<i class="x-icon-maxin-right"></i>
						</div>
						<div class="words">
							<p>
								I joined Xhorse to be the project assistant in 2020 and took on responsibility for the project of Automatic Key Cutting Machine. I graduated with a  master of project management degree in risk and control from the University of Sydney in 2020.
							</p>
							<p>
							</p>
							<p>
							</p>
						</div>
					</div>
					<div class="staff-photo x-flow">
						<img :src="staff_6" alt="Xhorse"/>
					</div>
				</li>-->
			</ul>
		</div>
		<div class="x-line"></div>
		<div class="process-con">
			<div class="title">
				<i class="x-icon-process"></i><span class="x-tit-con">Recruitment Process</span>
			</div>
			<div class="process">
				<img :src="process" alt="Xhorse"/>
			</div>
		</div>
	</div>
</template>

<script>
    import staff_1 from '@/assets/resource/images/join/image_recruit_01.png'
    import staff_2 from '@/assets/resource/images/join/image_recruit_02.png'
    import staff_3 from '@/assets/resource/images/join/image_recruit_03.png'
    import staff_4 from '@/assets/resource/images/join/image_recruit_04.png'
    import staff_5 from '@/assets/resource/images/join/image_recruit_05.png'
    import staff_6 from '@/assets/resource/images/join/image_recruit_06.png'
    import process from '@/assets/resource/images/join/image_recruit_07.png'
    export default {
        data (){
            return {
                staff_1: staff_1,
                staff_2: staff_2,
                staff_3: staff_3,
                staff_4: staff_4,
                staff_5: staff_5,
                staff_6: staff_6,
                process: process
            };
        }
    }

</script>

<style scoped>
	.about-xhorse {
		width: 100%;
		height: 100%;
	}

	.about-xhorse > .title {
		width: calc(61.5rem - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.title > .x-icon-why {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_xhorse.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.process-con > .title {
		width: calc(61.5rem - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.title > .x-icon-process {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_procedure.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.title > .x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-family: Open Sans;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.staff-con {
		width: 54.5rem;
		min-width: 54.5rem;
		/* margin: 0 auto; */
		margin-left: 7rem;
	}

	.staff-ll > li {
		width: 100%;
		min-height: 43.625rem;
	}

	.staff-ll > li:not(:last-child) {
		border-bottom: .125rem solid #D7D7D7;
		margin-bottom: 2.75rem;
	}

	.staff-photo > img {
		width: 100%;
	}

	.x-icon-maxin-left {
		display: block;
		content: url("../../../assets/resource/icons/ico_home_punctuation_left.png");
		position: relative;
		width: 5.125rem;
		height: 3.625rem;
		left: .3125rem;
		top: 1.6875rem;
		z-index: 0;
	}

	.x-icon-maxin-right {
		display: block;
		content: url("../../../assets/resource/icons/ico_home_punctuation_right.png");
		position: relative;
		width: 5.125rem;
		height: 3.625rem;
		left: 80%;
		z-index: 0;
	}

	.staff-ll > li:nth-child(even) > .staff-photo {
		width: 22rem;
		border: none;
		margin-left: 3rem;
	}

	.staff-ll > li:nth-child(even) .author {
		text-align: right;
	}

	.staff-ll > li:nth-child(even) > .staff-words {
		width: calc(100% - 22rem - 3rem);
		font-size: 1.25rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
	}

	.staff-ll > li:nth-child(odd) > .staff-photo {
		width: 22rem;
		margin-right: 3rem;
		border: none;
	}

	.staff-ll > li > .staff-words {
		min-height: 38.5rem;
		overflow: hidden;
	}

	.staff-ll > li:nth-child(odd) > .staff-words {
		width: calc((100% - 3rem - 22rem));
		font-size: 1.25rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;

	}

	.words > p {
		font-size: 1rem;
	}

	.words > p:last-child {
		/*margin-bottom: 2.75rem;*/
	}

	.maxim > p {
		margin-bottom: 1.375rem;
		font-size: 1.25rem;
	}

	.words > p:not(:last-child) {
		margin-bottom: 1.375rem;
	}

	.x-line {
		width: 100%;
		height: .75rem;
		border: none;
		background-color: #F7F8F8;
	}

	.process-con > .process {
		width: 54.5rem;
		min-width: 54.5rem;
		padding-left: 2.75rem;
	}

	.process > img {
		width: 80%;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/zh-cn/join/join-why.vue